export const TYPE_NONE = 0;
export const TYPE_RESV = 1;
export const TYPE_FAILURE = 2;
export const TYPE_CONTACT = 3;
export const TYPE_OTHER = 127;